module.exports = __webpack_public_path__ + "img/sessions.818fea33.svg";